var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('div',{staticClass:"w-full"},[_c('div',{staticClass:"animate-pulse"},_vm._l((10),function(n){return _c('div',{key:n,staticClass:"h-48 bg-gray-lightest rounded-2xl w-full mb-6"})}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }